export var ProductType;
(function (ProductType) {
    ProductType["RECURRING"] = "RECURRING";
    ProductType["RENTAL"] = "RENTAL";
    ProductType["ONETIME"] = "ONETIME";
    ProductType["PUBLIC"] = "PUBLIC";
    ProductType["AUTHENTICATED"] = "AUTHENTICATED";
})(ProductType || (ProductType = {}));
//# sourceMappingURL=ProductType.js.map